import * as actions from './card.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { ReportCardModel } from '@smarttask-common/src/lib/models/Report/Card/Main/ReportCardModel';

export const cardAdapter = createEntityAdapter<ReportCardModel>({
    selectId: (x) => x.card_id,
});
export interface ReportCardState extends EntityState<ReportCardModel> {
    selected_card_id: string;
}

export const initialState: ReportCardState = cardAdapter.getInitialState({
    selected_card_id: undefined,
});

export function ReportCardReducers(state: ReportCardState = initialState, action: actions.ReportCardActions) {
    switch (action.type) {
        case actions.ReportCardActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_card_id: action.selected_card_id };
            return state;

        case actions.ReportCardActionTypes.ADD_REPORT_CARD:
            return cardAdapter.addOne(action.card, state);

        case actions.ReportCardActionTypes.ADD_REPORT_CARDS:
            return cardAdapter.addMany(action.cards, state);

        case actions.ReportCardActionTypes.UPSERT_REPORT_CARD:
            return cardAdapter.upsertOne(action.card, state);

        case actions.ReportCardActionTypes.UPSERT_REPORT_CARDS:
            return cardAdapter.upsertMany(action.cards, state);

        case actions.ReportCardActionTypes.UPDATE_REPORT_CARD:
            return cardAdapter.updateOne(action.card, state);

        case actions.ReportCardActionTypes.UPDATE_REPORT_CARDS:
            return cardAdapter.updateMany(action.cards, state);

        case actions.ReportCardActionTypes.DELETE_REPORT_CARD:
            // if(state.selectedReportCardId == action.id){
            //   state.selectedReportCardId = undefined;
            // }
            return cardAdapter.removeOne(action.id, state);

        case actions.ReportCardActionTypes.DELETE_REPORT_CARDS:
            // if(action.ids.indexOf(state.selectedReportCardId) > -1){
            //   state.selectedReportCardId = undefined;
            // }
            return cardAdapter.removeMany(action.ids, state);

        case actions.ReportCardActionTypes.DELETE_ALL_REPORT_CARDS:
            return cardAdapter.removeMany(action.ids, state);

        case actions.ReportCardActionTypes.DELETE_ALL:
            return cardAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getReportCardState = createFeatureSelector<ReportCardState>('reportCard');

export const { selectIds, selectEntities, selectAll, selectTotal } = cardAdapter.getSelectors(getReportCardState);

const getSelectedReportCardIdState = (state: ReportCardState) => {
    return state.selected_card_id;
};
export const getSelectedReportCardId = createSelector(getReportCardState, getSelectedReportCardIdState);

export const getSelectedReportCard = createSelector(getReportCardState, (state: ReportCardState) => {
    if (state.selected_card_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_card_id];
});
